import packageJson from "../package.json";

/**
 * Global application configuration type definition
 */
export type GlobalConfig = {
	/** Application name */
	appName: string;
	/** Application version number */
	appVersion: string;
	/** Default route path for the application */
	defaultRoute: string;
	/** Public path for static assets */
	publicPath: string;
	/** Base URL for API endpoints */
	apiBaseUrl: string;
	/** Proxy target for local API requests */
	apiProxyTarget: string;
	/** Base URL for images returned by API */
	imageBaseUrl: string;
	/** Official production site URL */
	officialUrl: string;
};

/**
 * Global configuration constants
 * Reads configuration from environment variables and package.json
 *
 * @warning
 * Please don't use the import.meta.env to get the configuration, use the GLOBAL_CONFIG instead
 */
const env = import.meta.env ?? {};

export const GLOBAL_CONFIG: GlobalConfig = {
	appName: "GroupBuy",
	appVersion: env.VITE_APP_Version || packageJson.version,
	defaultRoute: env.VITE_APP_DEFAULT_ROUTE || "/home",
	publicPath: env.VITE_APP_PUBLIC_PATH || "/",
	apiBaseUrl: env.VITE_APP_API_BASE_URL || "/api",
	apiProxyTarget: env.VITE_APP_API_PROXY_TARGET || "",
	imageBaseUrl: env.VITE_APP_IMAGE_BASE_URL || "",
	officialUrl: env.VITE_APP_OFFICIAL_URL || "",
};
